import {
  Component, OnInit,
  ElementRef,
  Input
} from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";

export interface ConfirmModeluser {
  title: string;
  data: any;
  Items: any
}
@Component({
  selector: 'app-userrole-search',
  templateUrl: './userrole-search.component.html',
  styleUrls: ['./userrole-search.component.css']
})
export class UserroleSearchComponent extends DialogComponent<ConfirmModeluser, boolean> implements ConfirmModeluser, OnInit {
  Items: any
  title: string;
  message: string;
  data: any;
  loading: boolean = false
  result: any = { item: [], result: false }
  rtnData: any;
  selectedRow: number = -1
  sliceStrat: number = 0
  sliceEnd: number = 10
  Unit: string = ""
  Selected: boolean = false
  selectAll: boolean = false
  f: any = {
    Name: "",
    Company: "",
    Branch: "",
    Location: "",
  };
  fullData: any;
  private el: ElementRef
  @Input() onReturn: string
  constructor(dialogService: DialogService) {
    super(dialogService);
    this.fullData = this.data
    this.Items = this.Items;
  }

  ngOnInit() {

    var selectedcount = 0
    this.fullData = this.data;
    this.fullData.data.forEach(rp => {
      for (let i of this.Items) {
        if (rp.Id == i.Id) {
          rp.Selected = true
          selectedcount = selectedcount + 1
        }
      }
    });
    if (this.fullData.data.length == selectedcount) {
      this.selectAll = true
    }
    if (!this.fullData) {
      this.close();
    }
    else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 10
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 10
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.data.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 11
  }
  ItesmSearch(e, type) {

    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "Name":
          this.f.Name = e.target.value;
          break;
        case "Company":
          this.f.Company = e.target.value;
          break;
        case "Branch":
          this.f.Branch = e.target.value;
          break;
        case "Location":
          this.f.Location = e.target.value;
          break;
      }
      this.selectedRow = 0;
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {

    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.ok();
    }
    else return;
  }
  changeSelectAll(ix) {
    for (let i of this.fullData.data) {
      i.Selected = this.selectAll
    }
  }
  SelectionChange(e, y) {
    var chk = document.getElementById("d{{1}}")
    e.Selected = y
    var dd = true
    for (let i of this.fullData.data) {
      if (i.Selected == false) {
        dd = false
      }
    }
    this.selectAll = dd
  }
  ok() {
    var ab = []
    for (let i of this.fullData.data) {
      if (i.Selected) {
        ab.push(i)
      }
    }
    this.confirm(ab);
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/userrole-search/userrole-search.component.ts